import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import PlanCard from '../plan-card/plan-card';
import PropTypes from 'prop-types';

const modeProps = {
	horizontal: {
		xs: { span: 22, push: 1 },
		md: { span: 11, push: 0 },
		lg: { span: 12 }
	},
	vertical: {
		xs: { span: 22, push: 1 }
	}
};
export const PlansBox: React.FC<any> = ({ plans, ContentComponent, onSelect, mode = 'horizontal' }: any) => {
	return (
		<Row className="mb-3">
			{plans.map(p => (
				<Col {...modeProps[mode]}>
					<PlanCard
						title={p.title}
						features={p.features}
						price={p.price.usd}
						onSelect={() => {
							onSelect && onSelect(p);
						}}
					>
						{ContentComponent ? (
							<ContentComponent {...p} />
						) : (
							<span>
								<CheckOutlined
									className="me-2"
									style={{ fontSize: '1.5rem', fontWeight: 700, color: '#67D9AE' }}
								/>
								<span style={{ fontSize: '1.3rem' }}>{p.interviewsCount} Interviews </span>
							</span>
						)}
					</PlanCard>
				</Col>
			))}
		</Row>
	);
};

PlansBox.propTypes = {
	mode: PropTypes.oneOf(['horizontal', 'vertical'])
};

PlansBox.defaultProps = {
	mode: 'horizontal'
};
